import React, { useEffect, useState, useCallback } from "react";
import Home from "./HomeContainer";
import { connect } from "react-redux";
import { selectUserCurrentRide, selectUserLoggedIn, selectUserRegistered } from "../../store/user/reducer";
import CurrentRide from "./CurrentRide";
import { getRideApi } from "../../api";
import { useHistory } from "react-router";
import { message } from 'antd'
import { bindActionCreators } from "redux";
import { fetchMe } from "../../store/user/actions";
import { selectIntroShown } from "store/app/reducer";
import routesConfig from "routesConfig";

function HomeContainer({
    introShown, fetchMe,
    userLoggedIn, userRegistered, userCurrentRide }) {
    const history = useHistory()
    const [rideFinishing, setRideFinishing] = useState(false)

    useEffect(() => {
        fetchMe();
        if (!introShown) {
            history.push(routesConfig.intro)
        }
    }, [])

    const finishRide = () => {
        const finished = true;
        const rideId = userCurrentRide.id;
        setRideFinishing(true)
        getRideApi().finishRide({ rideId, finished })
            .then((response) => {
                fetchMe()
                if (response.status.toString() === "RESERVATIONCANCELED")
                    history.push(routesConfig.rideCanceled)
                else
                    gotoOrderPage(response.billingId)
            })
            .catch((error) => {
                message.error("خطا در ثبت پایان سفر!")
            })
            .finally(()=>setRideFinishing(false))
    }

    const gotoOrderPage = (billingId) => {
        history.push(routesConfig.order + '/' + billingId)
    }


    const hasOngoingRide = userLoggedIn && userRegistered && userCurrentRide && !userCurrentRide.finished
    const hasUnpaidRide = userLoggedIn && userRegistered && userCurrentRide && userCurrentRide.finished && userCurrentRide.billingId

    useEffect(() => {
        if (hasUnpaidRide) {
            gotoOrderPage(userCurrentRide.billingId)
        }
    }, [hasUnpaidRide, userCurrentRide])

    if (hasOngoingRide) {
        return <CurrentRide currentRide={userCurrentRide}
            finishRide={finishRide}
            rideFinishing={rideFinishing}
        />
    }
    return <Home />
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchMe,
    },
    dispatch);

const mapStateToProps = state => ({
    userRegistered: selectUserRegistered(state),
    userLoggedIn: selectUserLoggedIn(state),
    userCurrentRide: selectUserCurrentRide(state),
    introShown: selectIntroShown(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer)
